import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

import { IApplicationFormatted } from '../../../types';

import { appTabsContent } from './app-tabs-content';

type TUseAppDetailsParams = {
  application: IApplicationFormatted;
};

export default function useAppDetails({ application }: TUseAppDetailsParams) {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  const { formatMessage } = useIntl();

  const appContentList = useMemo(() => {
    return appTabsContent.map(({ title, content: Content }) => ({
      title: formatMessage({ id: title }),
      content: <Content currentApplication={application} isReadyToPublish={false} />,
    }));
  }, [application, formatMessage]);

  return { activeTabIndex, setActiveTabIndex, appContentList };
}
